import { render, staticRenderFns } from "./VFormModal.vue?vue&type=template&id=1ea21176&scoped=true"
import script from "./VFormModal.vue?vue&type=script&lang=ts"
export * from "./VFormModal.vue?vue&type=script&lang=ts"
import style0 from "./VFormModal.vue?vue&type=style&index=0&id=1ea21176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea21176",
  null
  
)

export default component.exports